import { Box, Stack } from "@mui/material";
import React, { useState } from "react";
import InterviewResponseModal from "./InterviewResponseModal";

const Interviews = ({ answers, resSubmitted, setResSubmitted }) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);

  console.log("answers >>>>>>>", answers);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  console.log({ answers })

  return (
    <Box
      sx={{
        backgroundColor: "white",
        padding: "20px 15px",
        width: "100%",
      }}
    >
      <Box>
        <Box>
          <p className="font-Poppins font-bold text-lg">
            Interviews
          </p>
        </Box>
        <Stack
          flexDirection="column"
          gap={1}
          sx={{
            maxHeight: "35rem",
            overflowY: "scroll",
            scrollbarWidth: "thin",
          }}
        >
          {answers?.map(
            (exam, index) =>
              // exam.hasOwnProperty("isGraded") && (
              <div
                className={`py-2 px-3 border ${exam.isGraded ? "border-black" : "border-red-500"
                  } cursor-pointer border bg-slate-50 flex items-center justify-between`}
                onClick={() => {
                  handleOpen(exam._id);
                  setData(exam);
                }}
                key={exam._id}
              >
                <p className="font-Poppins">
                  {index + 1}.{" " + exam?.doerId + " "} -  { exam?.name + " "} -{exam?.role + " "}
                </p> 
                <p className="font-Poppins text-sm">
                  {/* {exam?.interviewId} */}
                  {new Date(exam?.createdAt)?.toLocaleString() }
                  </p>
              </div>
            // )
          )}
        </Stack>
      </Box>
      {open && (
        <InterviewResponseModal handleClose={handleClose} open={open} data={data} setResSubmitted={setResSubmitted} resSubmitted={resSubmitted} />
      )}
    </Box>
  );
};

export default Interviews;
